import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

interface CostChartProps {
  data: Array<{ month: string; totalCost: number; scanCount: number }>;
}

export function CostChart({ data }: CostChartProps) {
  if (!data.length) {
    return (
      <div className="flex h-[300px] items-center justify-center text-sm text-muted-foreground">
        No data yet
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          className="text-muted-foreground"
        />
        <YAxis
          yAxisId="cost"
          tick={{ fontSize: 12 }}
          tickFormatter={(v: number) => `$${v.toFixed(2)}`}
          className="text-muted-foreground"
        />
        <YAxis
          yAxisId="scans"
          orientation="right"
          tick={{ fontSize: 12 }}
          className="text-muted-foreground"
        />
        <Tooltip
          formatter={(value: number, name: string) => {
            if (name === "totalCost") return [`$${value.toFixed(2)}`, "Cost"];
            return [value, "Scans"];
          }}
          contentStyle={{
            backgroundColor: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            color: "hsl(var(--popover-foreground))",
          }}
        />
        <Bar
          yAxisId="scans"
          dataKey="scanCount"
          fill="hsl(var(--accent))"
          opacity={0.3}
          radius={[4, 4, 0, 0]}
        />
        <Line
          yAxisId="cost"
          type="monotone"
          dataKey="totalCost"
          stroke="hsl(var(--accent))"
          strokeWidth={2}
          dot={{ r: 3 }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
